module.exports = __webpack_public_path__ + "static/img/login_logo.435bdb66.png";